module.exports = __webpack_public_path__ + "media/images/landing/studies/sq2-c5d8a202a4852777c83589c1424709c1.jpg";